"use client"

import type { CareerCenter } from "@/modules/careerCenter/types"
import type { I18nLocale } from "@/modules/i18n/types"
import type { CurrentUser } from "@/modules/user/api/types"
import type { ButtonHTMLAttributes, FunctionComponent, MouseEventHandler } from "react"

import { IconButton } from "@jobteaser/spark/components/IconButton"
import { ThumbDown } from "@jobteaser/spark/components/Icons/ThumbDown"
import { ThumbUp } from "@jobteaser/spark/components/Icons/ThumbUp"

import { useTracking } from "@/modules/tracking/useTracking"

type FeedbackButtonProps = {
  currentUserCurriculumIds: CurrentUser["attributes"]["curriculumIds"]
  feedback: "positive" | "negative"
  jobRoleId: string
  locale: I18nLocale
  schoolId: CareerCenter["id"]
} & ButtonHTMLAttributes<HTMLButtonElement>

export const FeedbackButton: FunctionComponent<FeedbackButtonProps> = ({
  currentUserCurriculumIds,
  feedback,
  jobRoleId,
  locale,
  schoolId,
  ...props
}) => {
  const tracking = useTracking()

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event): void => {
    tracking?.track("event_click", {
      course_ids: currentUserCurriculumIds,
      ref_ids: {
        job_role_ids: [jobRoleId],
      },
      role: feedback === "positive" ? "job-roles-feedback-positive" : "job-roles-feedback-negative",
      service: "generic_fe",
      trackee_locale: locale,
      trackee_school_id: schoolId,
    })

    if (typeof props.onClick !== "undefined") {
      props.onClick?.(event)
    }
  }

  return (
    <IconButton
      {...props}
      icon={feedback === "positive" ? ThumbUp : ThumbDown}
      onClick={handleClick}
      variant="outlined"
    />
  )
}
